import { Text, TouchableOpacity } from "react-native";
import React from "react";
import { LinearGradient } from "expo-linear-gradient";
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withSpring,
} from "react-native-reanimated";

const StatsCard = ({
  titel = "",
  number = "",
  cardstyling = "",
  textStyling = "",
  titleStyling = "",
}) => {
  const scale = useSharedValue(1);
  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{ scale: scale.value }],
  }));

  return (
    <Animated.View style={[{ flex: 1 }, animatedStyle]}>
      <TouchableOpacity
        activeOpacity={0.9}
        className={`${cardstyling} items-center justify-center flex flex-col py-2 px-4`}
        style={{
          borderRadius: 30,
          marginTop: 10,
          overflow: "hidden",
        }}
        onPressIn={() => {
          scale.value = withSpring(0.95, { damping: 15, stiffness: 300 });
        }}
        onPressOut={() => {
          scale.value = withSpring(1, { damping: 15, stiffness: 300 });
        }}
      >
        <LinearGradient
          colors={["#ffffff", "#e5e7eb", "#cbd5e1"]}
          locations={[0, 0.28, 0.99]}
          style={{
            paddingHorizontal: 20,
            paddingVertical: 12,
            width: "100%",
            borderRadius: 30,
          }}
        >
          <Text
            className={`${titleStyling} text-primaryV2 text-2xl font-bold text-center`}
            numberOfLines={1}
          >
            {titel}
          </Text>
          <Text
            className={`${textStyling} text-xl font-semibold py-4 text-center`}
            numberOfLines={1}
            adjustsFontSizeToFit
          >
            {number}
          </Text>
        </LinearGradient>
      </TouchableOpacity>
    </Animated.View>
  );
};

export default StatsCard;
